import { NgModule } from '@angular/core';
import { CurrencyComponent } from './currency.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { MomentModule } from 'ngx-moment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


@NgModule({ declarations: [
        CurrencyComponent,
    ],
    exports: [CurrencyComponent], imports: [CommonModule,
        FormsModule,
        MomentModule,
        PipesModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CurrencyModule {
}
